// extracted by mini-css-extract-plugin
module.exports = {"root":"File_root__16p5W","link":"File_link__2ccqA","item":"File_item__2YyGe"};